
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Title } from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Title`}</h1>
<p>{`Usage`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Title } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<>
  <Title size={1}>Heading 1</Title>
  <Title size={2}>Heading 2</Title>
  <Title size={3}>Heading 3</Title>
  <Title size={4}>Heading 4</Title>
</>`} mdxType="Playground">
  <>
    <Title size={1} mdxType="Title">Heading 1</Title>
    <Title size={2} mdxType="Title">Heading 2</Title>
    <Title size={3} mdxType="Title">Heading 3</Title>
    <Title size={4} mdxType="Title">Heading 4</Title>
  </>
</Playground>
<h3>{`Interactive Example`}</h3>
<Playground __position={1} __code={`<Title><span style={{ fontWeight: 500 }}>Title</span> text</Title>`} component={Title} mdxType="Playground">
  <Title mdxType="Title"><span style={{
          fontWeight: 500
        }}>Title</span> text</Title>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;